import { AppIntegrationsRepository, LicensesRepository, ActivationCodesRepository, DevicesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

/**
 * @ngdoc service
 * @name controllers.WelcomeModal
 *
 * @description
 * Welcome Modal
 */
angular.module('controllers')
    .controller(
        'WelcomeModal',
        (
            $scope, $state, $document, LicenseRestService,
            Sso, ActivationCodeRestService, Util, DeployRestService,
        ) => {

            angular.element($document[0].body).addClass('splash-screen');

            // retrieve the x-a-* params and forward them to the backend
            const ssoParams = Sso.getParams();
            const metaParams = {};
            Object.keys(ssoParams).forEach((key) => {

                if (key.indexOf('x-a-') > -1) {

                    metaParams[key] = ssoParams[key];

                }

            });

            $scope.license = LicensesRepository.getLicenseByAppId($state.params.resourceId);
            $scope.brandName = CWCONFIG.partnerConfig.name;
            $scope.product = AppIntegrationsRepository.getAppName('aps10');
            if (!$scope.license) {

                const licensePayload = {
                    data: {
                        relationships: {
                            app: {
                                data: {
                                    type: 'apps',
                                    id: $state.params.resourceId,
                                },
                            },
                        },
                    },
                    meta: {
                        'x-params': metaParams,
                    },
                };
                // add campgain param in meta
                if (metaParams['x-a-channel']) {

                    licensePayload.meta.cmp = metaParams['x-a-channel'];

                }
                LicenseRestService.create(licensePayload).then((license) => {

                    $scope.license = license;

                    // get activationCode after the license is received
                    ActivationCodeRestService.getAllAsync().then((response) => {

                        ActivationCodesRepository.replace(response.data.data);

                    });

                }).catch(() => {

                    Util.closeModal();

                });

            }

            const mixpanelPayload = {
                Source: metaParams['x-a-source'],
                Modal: 'Prime Trial Welcome Modal',
                Page: Util.getPageName(),
            };

            Mixpanel.send('ConnectWeb Modal Open ', mixpanelPayload);

            $scope.$on('$destroy', () => {

                angular.element($document[0].body).removeClass('splash-screen');

            });

            $scope.installApp = () => {

                const mixpanelData = {
                    Modal: 'Prime Trial Welcome Modal',
                    'Button Label': 'Install now',
                    'Product ID': $state.params.resourceId,
                    Page: Util.getPageName(),
                };

                Mixpanel.send('ConnectWeb Modal Button Click', mixpanelData);

                const devices = DevicesRepository.getVisibleDevices();

                devices.forEach((device) => {

                    // if device has Windows OS
                    if (device.attributes.os === 'windows') {

                        const deploymentPayload = {
                            deviceId: device.id,
                            userId: Util.deepFind(device, 'relationships.user.data.id'),
                            appId: 'aps10',
                        };

                        DeployRestService
                            .deployOnDevice(deploymentPayload)
                            .then(() => {

                                $state.go('root.dashboard.home');

                            })
                            .then(null, (e) => {

                                /* 409 === Conflict
                                An instance for this application already
                                exists (pending) - ignore */
                                if (e.status === 409) {

                                    return;

                                }

                                Alert.error({
                                    message: 'cw.modal.server-error.desc',
                                    icon: {

                                        cssClasses: `icon-${Util.deepFind(device, 'attributes.type')}`,

                                    },

                                });

                            });

                    }

                });

            };

            $scope.closeModal = () => {

                Util.closeModal();

            };

        },

    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/welcome-modal/welcome-modal.js